<template>
  <div class="ctn">
    <div class="hdr-tools">
      <div class="input-item">
        <div class="hdr-tools-name">密钥名:</div>
        <el-input size="mini" class="hdr-tools-input" v-model="name" @keyup.native.enter="genKey" />
      </div>

      <div class="input-item">
        <div class="hdr-tools-name">密钥密码:</div>
        <el-input size="mini" class="hdr-tools-input" v-model="password" show-password @keyup.native.enter="genKey" placeholder="留空则不加密" />
      </div>

      <el-button class="hdr-tools-btn" size="mini" type="primary" @click="genKey">生成</el-button>
    </div>
    <div class="validate-result">{{tips}}</div>
  </div>
</template>

<script>
export default {
  name: "genKey",
  data() {
    return {
      name: undefined,
      tips: undefined,
      password: "",
    }
  },
  watch: {
    name: function() {
      if (this.name === "" || this.name === undefined) {
        this.tips = "密钥名不能为空"
        return
      }

      let self = this
      this.api.hifs.getPath(self.path, (error, data, response) => {
        if (error) {
          self.api.errHandler(self, error, response)
          self.tips = "检查同名密钥是否存在出错"
        } else {
          // 文件已存在
          if (data == true) {
            self.tips = "同名密钥已存在"
            return
          }
          self.tips = ""
        }
      })
    }
  },
  computed: {
    path: function() {
      return `/keys/${this.name}`
    },
  },
  methods: {
    genKey: function() {
      let self = this
      if (this.name === "" || this.name === undefined) {
        this.tips = "密钥名不能为空"
        return
      }

      let opts = {
        'password': this.password, // String | 密码
        'cipher': "rsa" // String | 加密算法, 支持 rsa/dsa/ecdsa/ed25519, 默认为 rsa
      };
      this.api.key.postKeyNew(self.name, opts, (error, data, response) => {
        if (error) {
          self.api.errHandler(self, error, response)
        } else {
          self.$message.success(`生成密钥 ${self.name} 成功`)
          self.$emit("addSuccess")
        }
      });
    },
  },
}
</script>

<style scoped>
.ctn {
  display: flex;
  flex-direction: column;
}
.hdr-tools {
  display: flex;
  justify-content: space-between;
}
.input-item {
  display: flex;
  align-items: baseline;
}
.hdr-tools-name {
  flex-grow: 0;
  padding-right: 0.5em;
  word-break: keep-all;

  user-select: none;
}
.hdr-tools-input {
  width: 180px;
}

.validate-result {
  width: 100%;
  padding-top: 0.6em;
  font-size: 0.8em;

  display: flex;
  justify-content: flex-end;
  color:brown;
}
</style>
